import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
// material
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Avatar,
  Box,
  Grid
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// component
import Iconify from '../../../components/Iconify';
import { api } from 'src/Api';
import Alert from '@mui/material/Alert';
import { Encryption } from 'src/functions/function';
import { PhotoCamera } from '@mui/icons-material';

// ----------------------------------------------------------------------

export default function RegisterForm() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [rolesData, setRolesData] = useState([]);
  const [file, setfile] = useState({ image: '', file: '' });
  const [alert, setalert] = useState({ visible: false, message: '' });

  // useEffect(() => {
  //   getRoles();
  // }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9_\-]+\.)+[a-zA-Z]{2,7}(\/[a-zA-Z0-9_\-#]+\/?)*$/;

  // // Validation schema with first name, last name, role, phone number, and password
  // const RegisterSchema = Yup.object().shape({
  //   firstName: Yup.string().required('First name is required'),
  //   lastName: Yup.string().required('Last name is required'),
  //   role: Yup.string().required('Role is required'),
  //   company: Yup.string().required('Company is required'),
  //   email: Yup.string().email('Email must be a valid email address').required('Email is required'),
  //   password: Yup.string().min(8, 'Password must be at least 8 characters long').required('Password is required'),
  //   confirmPassword: Yup.string()
  //     .oneOf([Yup.ref('password'), null], 'Passwords must match')
  //     .required('Confirm password is required'),
  // });

  // Validation schema with conditional company field
  const RegisterSchema = Yup.object().shape({
    firstName: Yup.string().required('Business Name is required'),

    contact: Yup.string()
      // .matches(/^\d{20}$/, 'Business Contact must contain exactly 20 digits')
      .max(20, 'Bussiness Contact is not exceed 20 digits')
      .required('Bussiness Contact is required'),
    email: Yup.string()
      .email('Email must be a valid email address')
      .required('Bussiness Email is required'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters long')
      .required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Confirm password is required'),
    address: Yup.string()
      .max(100, 'The Address cannot exceed 100 characters')
      .required('Bussiness Address is required'),
    websiteUrl: Yup.string()
      .max(50, 'Website Url is not exceed 50 characters')
      .matches(urlRegex, 'Invalid URL format')
      .optional()
  });

  // const formik = useFormik({
  //   initialValues: {
  //     firstName: '',
  //     lastName: '',
  //     role: '',
  //     company: '',
  //     email: '',
  //     password: '',
  //     confirmPassword: ''
  //   },
  //   validationSchema: RegisterSchema,
  //   onSubmit: () => {
  //     Register();
  //   }
  // });

  // Formik form
  const formik = useFormik({
    initialValues: {
      firstName: '',
      email: '',
      password: '',
      confirmPassword: '',
      websiteUrl: '',
      address: '',
      contact: '',
      avatar: ''
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      Register();
    }
  });

  const { errors, values, touched, handleSubmit, getFieldProps, setFieldValue } = formik;
  console.log('bussiness address', values.address.length);
  function Register() {
    setIsSubmitting(true);

    const formData = new FormData();
    // Encrypt the form values before submitting
    formData.append('name', values?.firstName);
    formData.append('contact', values?.contact);
    formData.append('email', values?.email);
    formData.append('password', values?.password);
    formData.append('confirm_password', values?.confirmPassword);
    formData.append('website_link', values.websiteUrl);
    formData.append('address', values.address);

    if (file && file.file) {
      formData.append('avatar', file?.file);
    }

    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow'
    };

    fetch(api.register, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          // console.log('response of signup', response);

          return response.json();
        } else {
          return response.json().then((error) => {
            console.log('errror======>>>', error?.message);
            // setSnackbarMessage(error.message);
            setalert({ visible: true, message: error?.message });
          });
        }
      })
      .then((result) => {
        if (result.success == true) {
          localStorage.setItem('email', values?.email);
          navigate('/otpVerification', {
            replace: true,
            state: {
              email: values.email,
              user: result?.data,
              token: result?.token,
              message: result?.message,
              from: 'signup',
              code: result?.code
            }
          });
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        setSnackbarMessage(error.message);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  // const Register = () => {
  //   setIsSubmitting(true);
  //   const formData = new FormData();

  //   // Encrypt the form values before submitting
  //   formData.append('first_name', Encryption(values?.firstName, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('last_name', Encryption(values?.lastName, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('company', Encryption(values?.company, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('email', Encryption(values?.email, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('password', Encryption(values?.password, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('role_id', Encryption(values?.role, process.env.REACT_APP_SECRET_KEY));
  //   formData.append('password_confirmation', Encryption(values?.confirmPassword, process.env.REACT_APP_SECRET_KEY));

  //   const requestOptions = {
  //     method: 'POST',
  //     body: formData,
  //     redirect: 'follow'
  //   };

  //   fetch(api.register, requestOptions)
  //     .then((response) => {
  //       console.log("🚀 ~ .then ~ response:", response)
  //       if (response.status === 200 || response.status === 201) {
  //         console.log("🚀 ~ .then ~ result:", response)
  //         localStorage.setItem('email', values?.email)
  //         navigate('/otpVerification', {
  //           replace: true,
  //           state: {
  //             user: response?.data?.data,
  //             token: response?.data?.access_token,
  //             message: response?.data?.message,
  //             from: 'signup'
  //           }
  //         });
  //         return response.json();
  //       } else {
  //         return response.json().then((error) => {
  //           setSnackbarMessage(error.error);
  //           setSnackbarSeverity('error');
  //           setSnackbarOpen(true);
  //         });
  //       }
  //     })
  //     .finally(() => {
  //       setIsSubmitting(false);
  //     });
  // };

  const getRoles = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(api.getRoleSignUp, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else {
          return response.json().then((error) => {});
        }
      })
      .then((result) => {
        console.log('🚀 ~ .then ~ result:', result);
        setRolesData(result.data);
      })
      .catch((error) => {
        console.log('🚀 ~ getRoles ~ error:', error);
      })
      .finally(() => {});
  };
  const [objAfter, setobjAfter] = useState({
    name: '',
    file: false
  });
  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

  console.log('file image ======', file);
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2} sx={{ mb: 0 }}>
          {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}> */}
          {/* 
          <Stack
            mb={2}
            direction={{ xs: 'column' }}
            style={{ display: 'flex', flexDirection: 'row' }}
            className="image_center"
          >
            <Box display="flex" justifyContent="center" mb={2} position="relative">
              {file && (
                <Avatar
                  alt={values.firstName}
                  src={objAfter.file ? file.image : file.image + `?v='${Date.now()}`}
                  sx={{ width: 120, height: 120 }}
                  className="image_center"
                />
              )}

              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 5,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  height: 30,
                  width: 30
                }}
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(e) => {
                    setobjAfter({
                      file: true
                    });
                    setfile({
                      image: URL.createObjectURL(e.target.files[0]),
                      file: e.target.files[0]
                    });
                  }}
                />
                <PhotoCamera sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Stack> */}

          <Stack
            mb={2}
            direction={{ xs: 'column' }}
            style={{ display: 'flex', flexDirection: 'row' }}
            className="image_center"
          >
            <Box display="flex" justifyContent="center" mb={2} position="relative">
              {file && (
                <Avatar
                  alt={values.firstName}
                  src={file.image ? file.image : require('../../../asset/business.png')}
                  sx={{ width: 120, height: 120 }}
                  className="image_center"
                />
              )}

              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 5,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  height: 30,
                  width: 30
                }}
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const imageUrl = URL.createObjectURL(file);
                      // setfile(imageUrl); // for preview
                      setfile({
                        image: URL.createObjectURL(e.target.files[0]),
                        file: e.target.files[0]
                      });
                      // formik.setFieldValue('file', file); // Update Formik state
                    }
                  }}
                />
                <PhotoCamera sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Business Name"
                {...getFieldProps('firstName')}
                error={Boolean(touched.firstName && errors.firstName)}
                helperText={touched.firstName && errors.firstName}
                // className='custom-textfield'
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="email"
                label="Business Email"
                {...getFieldProps('email')}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && errors.email}
              />
            </Grid>

            {/* <TextField
            fullWidth
            required
            label="Last Name"
            {...getFieldProps('lastName')}
            error={Boolean(touched.lastName && errors.lastName)}
            helperText={touched.lastName && errors.lastName}
          /> */}
            {/* </Stack> */}

            {/* Dropdown for Role */}
            {/* <FormControl fullWidth>
            <InputLabel>Role</InputLabel>
            <Select
              label="Role"
              value={values.role}
              onChange={(e) => setFieldValue('role', e.target.value)}
              error={Boolean(touched.role && errors.role)}
            >
              {rolesData.map((val) => {
                return <MenuItem value={val.id}>{val.role_name}</MenuItem>;
              })}
              {/* <MenuItem value={1}>Admin</MenuItem>
              <MenuItem value={2}>Manager</MenuItem>
              <MenuItem value={3}>User</MenuItem> */}
            {/* </Select>
            {touched.role && errors.role && (
              <div style={{ color: '#FF4842', fontSize: 12, marginLeft: 14, marginTop: 4 }}>
                {errors.role}
              </div>
            )}
          </FormControl> */}

            {/* <TextField
            fullWidth
            required={values?.role == 1 || values?.role == 2 ? true : false}
            // type="email"
            label="Company"
            {...getFieldProps('company')}
            error={Boolean(touched.company && errors.company)}
            helperText={touched.company && errors.company}
          /> */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required={values.contact} // Conditionally set the "required" attribute
                label="Business Contact"
                {...getFieldProps('contact')}
                onChange={(e) => {
                  const value = e.target.value;
                  // Update only if it contains numbers and is 20 digits or fewer
                  if (/^\d*$/.test(value) && value.length <= 20) {
                    formik.setFieldValue('contact', value);
                  }
                }}
                error={Boolean(touched.contact && errors.contact)}
                helperText={touched.contact && errors.contact}
                type="number"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required={values.address} // Conditionally set the "required" attribute
                label="Business Address"
                {...getFieldProps('address')}
                error={Boolean(touched.address && errors.address)}
                helperText={touched.address && errors.address}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                required={values?.websiteUrl} // Conditionally set the "required" attribute
                label="Business Website (Optional)"
                {...getFieldProps('websiteUrl')}
                error={Boolean(touched.websiteUrl && errors.websiteUrl)}
                helperText={touched.websiteUrl && errors.websiteUrl}
                // {...getFieldProps('websiteUrl')}
                // error={Boolean(touched.company && errors.company)}
                // helperText={touched.company && errors.company}
              />
            </Grid>
            {/* Password Field */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                label="Password"
                {...getFieldProps('password')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {/* Confirm Password Field */}
              <TextField
                fullWidth
                required
                autoComplete="confirm-password"
                type={showConfirmPassword ? 'text' : 'password'}
                label="Confirm Password"
                {...getFieldProps('confirmPassword')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                      >
                        <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                helperText={touched.confirmPassword && errors.confirmPassword}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
              style={{ marginLeft: 16 }}
            >
              Sign up
            </LoadingButton>
          </Grid>

          <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
